import { get, postForm } from "api/http"
import { profileURL } from "api/urls"
import { clearAuthenticated } from "store/app/actions"

// FETCH_PROFILE

export const fetchProfileStart = () => ({
  type: "FETCH_PROFILE_START",
})

export const fetchProfileSuccess = (payload) => ({
  type: "FETCH_PROFILE_SUCCESS",
  payload,
})

export const fetchProfileError = (payload) => ({
  type: "FETCH_PROFILE_ERROR",
  payload,
})

export const fetchProfile = () => async (dispatch, getState) => {
  try {
    dispatch(fetchProfileStart())
    const response = await get(profileURL())

    if (response.status === 200 && response.redirected === false) {
      const json = await response.json()
      dispatch(fetchProfileSuccess(json))
    } else {
      if (response.status === 403 || response.redirected === true) {
        dispatch(clearAuthenticated())
      }

      dispatch(fetchProfileError())
    }
  } catch (e) {
    dispatch(fetchProfileError(e))
  }
}

// UPDATE_PROFILE

export const updateProfileStart = (payload) => ({
  type: "UPDATE_PROFILE_START",
  payload,
})

export const updateProfileSuccess = (payload) => ({
  type: "UPDATE_PROFILE_SUCCESS",
  payload,
})

export const updateProfileError = (payload) => ({
  type: "UPDATE_PROFILE_ERROR",
  payload,
})

export const updateProfile = (first_name, last_name, email) => async (
  dispatch,
  getState,
) => {
  const { entry } = getState().profile

  const body = {
    ...entry,
    first_name,
    last_name,
    email,
  }

  try {
    dispatch(updateProfileStart(body))
    const response = await postForm(profileURL(), { body: body })
    const json = await response.json()

    if (response.status === 200 && response.redirected === false) {
      dispatch(updateProfileSuccess(body))
    } else {
      if (response.status === 403 || response.redirected === true) {
        dispatch(clearAuthenticated())
      }

      dispatch(updateProfileError(json))
    }
  } catch (e) {
    dispatch(updateProfileError(e))
  }
}
